import { render, staticRenderFns } from "./Prestations.vue?vue&type=template&id=a7bf2cd2&scoped=true&"
import script from "./Prestations.vue?vue&type=script&lang=js&"
export * from "./Prestations.vue?vue&type=script&lang=js&"
import style0 from "./Prestations.vue?vue&type=style&index=0&id=a7bf2cd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bf2cd2",
  null
  
)

export default component.exports